import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { DatePicker } from "../../../components/ui/date-picker";
import { format } from "date-fns";
import { RadioGroup, RadioGroupItem } from "@/src/components/ui/radio-group";
import React from "react";

export const StartDate = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Start date</h3>
      <FormField<FiltersFormT, "charterDateType">
        name="charterDateType"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <RadioGroup defaultValue={field.value} onValueChange={field.onChange}>
                  <FormItem className="flex items-center gap-4 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="is" />
                    </FormControl>
                    <FormLabel className="font-light text-base">Is</FormLabel>
                    {field.value === "is" ? <DatePickerCharterDateFrom /> : null}
                  </FormItem>
                  <FormItem className="flex items-center gap-4 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="before" />
                    </FormControl>
                    <FormLabel className="font-light text-base">Before</FormLabel>
                    {field.value === "before" ? <DatePickerCharterDateFrom /> : null}
                  </FormItem>
                  <FormItem className="flex items-center gap-4 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="after" />
                    </FormControl>
                    <FormLabel className="font-light text-base">After</FormLabel>
                    {field.value === "after" ? <DatePickerCharterDateFrom /> : null}
                  </FormItem>
                  <FormItem className="flex items-center gap-4 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="between" />
                    </FormControl>
                    <FormLabel className="font-light text-base">Between</FormLabel>
                    {field.value === "between" ? (
                      <React.Fragment>
                        <DatePickerCharterDateFrom />
                        <span>and</span>
                        <DatePickerCharterDateTo />
                      </React.Fragment>
                    ) : null}
                  </FormItem>
                </RadioGroup>
              </FormControl>
            </FormItem>
          );
        }}
      />
    </div>
  );
};

const DatePickerCharterDateFrom = () => {
  return (
    <FormField<FiltersFormT, "charterStartDateFrom">
      name="charterStartDateFrom"
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <DatePicker
              className="w-64"
              onChange={(v) => {
                field.onChange(v ? format(v, "yyyy-MM-dd") : null);
                return new Date(v);
              }}
              value={field.value ? new Date(field.value) : undefined}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

const DatePickerCharterDateTo = () => {
  return (
    <FormField<FiltersFormT, "charterStartDateTo">
      name="charterStartDateTo"
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <DatePicker
              className="w-64"
              onChange={(v) => {
                field.onChange(v ? format(v, "yyyy-MM-dd") : null);
                return new Date(v);
              }}
              value={field.value ? new Date(field.value) : undefined}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
